pageId = 'members-batch_destroys-new'
page = '#'+pageId

$ ->
  $('body')
    .on 'tr-identity-verifier:success', page, (e) ->
      dialog = simple.dialog.confirm
        content: "确定删除选中成员吗？"
        buttons: [{
          text: "确定",
          callback: ->
            dialog.remove()
            $('.members-batch-destroy-form').trigger('submit')
        }, {
          text: "取消",
          cls: "btn-x",
          callback: (e)->
            dialog.remove()
        }]

$(document)
  .on 'pjaxload#' + pageId, (e, $page, page) ->
    tower.initManageMembers($page, true)
